<template>
  <div class="ppcThumbnail" >
    <!--<thumbNailDropDown />-->
    <Keypress key-event="keydown" :key-code="38" @success="prev()" :preventDefault="true"/>
    <Keypress key-event="keydown" :key-code="40" @success="next()" :preventDefault="true"/>
    <div class="cards ppcThumbnail__cards">
      <PPCThumbnailCard
          v-for="(P,index) in board.creative"
          :key="index"
          :selectedidx="$parent.selectedCreativeIdx "
          :creative="(P.status == 'draft' && !accountView && P.child) ? P.child : P"
          :child="(P.status == 'draft' && !accountView && P.child) ? true :false"
          :index="index"
          :selected="index === $parent.selectedCreativeIdx || isSelected(index) "
          :accountView="accountView"
      />    
    </div>
      <div class="buttonCard">
        <a class="btn btn-blue downloadAllButton" :href="getAbsoluteUrl(`helper/download_board/${board.slug}`)">download
          all</a>
      </div>
  </div>
</template>


<script>
import PPCThumbnailCard from './PPCThumbnailCard';
//import thumbNailDropDown from './thumbNailDropDown'
import apiHandlerMI from "@/mixins/apiHandlerMI.js";

export default {
  components: {
    Keypress: () => import('vue-keypress'),
    PPCThumbnailCard,
    //thumbNailDropDown
  },
  props: ['selected', 'board', 'accountView'],
  mixins: [apiHandlerMI],
  methods: {

    prev() {
      while (this.board.creative[this.$parent.selectedCreativeIdx].parent_id != 0) {
        for (var i = 0; i < this.board.creative.length; i++) {
          if (this.board.creative[this.$parent.selectedCreativeIdx].parent_id == this.board.creative[i].id) {
            this.$parent.selectedCreativeIdx = i;
          }
        }
      }
      for (i = this.$parent.selectedCreativeIdx; i >= 0; i--) {
        //console.log(i);
        if (this.board.creative[i].parent_id == 0 && i != this.$parent.selectedCreativeIdx) {
          this.selectCreative(i);
          return;
        }
      }
    },
    next() {
      while (this.board.creative[this.$parent.selectedCreativeIdx].parent_id != 0) {
        for (var i = 0; i < this.board.creative.length; i++) {
          if (this.board.creative[this.$parent.selectedCreativeIdx].parent_id == this.board.creative[i].id) {
            this.$parent.selectedCreativeIdx = i;
          }
        }
      }
      for (i = this.$parent.selectedCreativeIdx; i < this.board.creative.length; i++) {
        if (this.board.creative[i].parent_id == 0 && i != this.$parent.selectedCreativeIdx) {
          this.selectCreative(i);
          return;
        }
      }
    },
    selectCreative: function (creative_idx) {
      //console.log('select');
      this.$store.state.locationViewMode = false;
      this.$store.state.view_comment = false;
      this.$parent.selectedCreativeIdx = creative_idx
      //console.log(this.$parent.selectedCreativeIdx);
      this.$parent.$forceUpdate();
    },
    selectCreativeById(id){

       this.$store.state.locationViewMode=false;
        this.$store.state.view_comment=false;
       for (var i = 0; i< this.board.creative.length; i++){
         
         if (this.board.creative[i].id == id){
           this.$parent.selectedCreativeIdx = i;
           this.$parent.$forceUpdate();
         }
       }
     },
    isSelected(index) {
      let current = this.board.creative[this.$parent.selectedCreativeIdx];
      while (current && current.parent_id && current.parent_id !== '0') {
        current = this.board.creative.find(c => c.id === current.parent_id);
      }
      return current.id === this.board.creative[index].id;
    }
  }
};
</script>

